import PageCompiler from '@edools/page-compiler'
import lodashCloneDeep from 'lodash.clonedeep'
import lodashMerge from 'lodash.merge'
import lodashIsEmpty from 'lodash.isempty'
import { uuid } from 'vue-uuid'

const WIDGETS = PageCompiler.defaults.widgets

export default (id, type, path, options) => {
  const widgetType = `widget/${type}`
  const widget = lodashCloneDeep(WIDGETS[widgetType])

  widget.id = id
  widget.path = path

  if (widget.type === 'widget/Form') {
    widget.options.items.forEach(item => (item.id = uuid.v1()))
  }

  if (!lodashIsEmpty(options)) {
    lodashMerge(widget.options, options)
  }

  return widget
}
